import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { Reveal } from "../components/Reveal";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="bg-nero min-h-screen flex items-center justify-center grain relative pt-24">
      <SEO title="Questo calice è vuoto" path="/404" description="La pagina che cerchi non esiste." />
      <div className="text-center px-5">
        <Reveal>
          <svg viewBox="0 0 80 120" className="mx-auto mb-8 w-16 opacity-80" aria-hidden="true">
            <path d="M20 10 h40 c0 30 -10 42 -20 44 c-10 -2 -20 -14 -20 -44 Z" fill="none" stroke="#B0832F" strokeWidth="2" />
            <line x1="40" y1="54" x2="40" y2="100" stroke="#B0832F" strokeWidth="2" />
            <line x1="24" y1="100" x2="56" y2="100" stroke="#B0832F" strokeWidth="2" />
          </svg>
          <h1 className="font-serif text-4xl sm:text-5xl font-bold text-panna">Questo calice è vuoto.</h1>
          <p className="mt-5 text-panna/60">La pagina che cerchi non c'è. O è finita, come le buone bottiglie.</p>
          <Link to="/" data-testid="not-found-home"
                className="mt-10 inline-block rounded-full bg-bordeaux px-8 py-4 font-medium text-panna border border-oro/30 hover:bg-bordeaux-dark transition-colors">
            Torna alla Home
          </Link>
        </Reveal>
      </div>
    </div>
  );
}
